import { t } from "i18next";

import TitledPage from "@/modules/common/components/layout/pages/TitledPage";

const CustomersPage = () => {
  return <TitledPage title={t("Admin Customers")}></TitledPage>;
};

export default CustomersPage;
